import { type ExtractPropTypes, defineComponent, ref } from 'vue'
import { createNamespace, truthProp } from '@xzx-design/utils'
import { useChildren } from '@xzx-design/hooks'
import { usePlaceholder } from '../../nav-bar/src/use-placeholder'

const [name, bem] = createNamespace('action-bar')

export const ACTION_BAR_KEY = Symbol(name)

export const actionBarProps = {
  placeholder: Boolean,
  safeAreaInsetBottom: truthProp,
}

export type ActionBarProps = ExtractPropTypes<typeof actionBarProps>

export default defineComponent({
  name,

  props: actionBarProps,

  setup(props, { slots }) {
    const root = ref<HTMLElement>()
    const renderPlaceholder = usePlaceholder(root, bem)
    const { linkChildren } = useChildren(ACTION_BAR_KEY)

    linkChildren()

    const renderActionBar = () => (
      <div
        ref={root}
        class={[bem(), { 'van-safe-area-bottom': props.safeAreaInsetBottom }]}
      >
        {slots.default?.()}
      </div>
    )

    return () => {
      if (props.placeholder) {
        return renderPlaceholder(renderActionBar)
      }
      return renderActionBar()
    }
  },
})
